import { userApi } from "@/service/client";
import { useQuery } from "@tanstack/react-query";

export const userQueryKey = "user-me";

export const useUserController = ({
  ignoreException = false,
}: { ignoreException?: boolean } = {}) => {
  const { data: user, isLoading } = useQuery({
    queryKey: [userQueryKey],
    queryFn: async () => {
      try {
        const response = await userApi.getMe();
        return response ?? null;
      } catch (error) {
        if (ignoreException) {
          return null;
        }

        throw error;
      }
    },
  });

  const { data: userData, isLoading: isLoadingUserData } = useQuery({
    queryKey: ["user-data", user?._id],
    queryFn: async () => {
      const response = await userApi.getUserData();
      return response ?? null;
    },
    enabled: !!user?._id,
  });

  return {
    user,
    isLoading,
    userData,
    isLoadingUserData,
  };
};
